import { useCallback, useReducer } from "react";
import { useSelector } from "react-redux";
import * as userRepo from "../../../../shared/repos/graphql/user";

export default function useSavedLocations() {
  const userToken = useSelector(state => state.user.userToken);
  const [state, setState] = useReducer((currentState, partialState) => ({
    ...currentState,
    ...partialState,
  }), {
    error: null,
    loading: false,
    locations: undefined,
    fetched: false,
  });

  const fetchLocations = useCallback(async () => {
    if (! userToken) return;

    setState({ loading: true });

    try {
      const result = await userRepo.getSavedLocations();
      setState({ locations: result.data.me.savedLocations.locations });
    } catch (error) {
      setState({ error });
    } finally {
      setState({ loading: false, fetched: true });
    }
  }, [userToken]);

  return {
    error: state.error,
    loading: state.loading,
    locations: state.locations,
    fetch: fetchLocations,
    fetched: state.fetched,
  };
}